@if (chatForm) {
  @if (isResolved) {
    <div class="chat-message-form-summary-header">
      <i [nimbusIcon]="ICONS.CHECK_CIRCLE"></i>
      <span>{{ TranslationKeys.CompanionChatSubmittedValues | translate }}</span>
    </div>
    <dl class="chat-message-form-summary">
      @for (field of chatForm.fields; track field.name) {
        <div class="chat-message-form-summary-row">
          <dt>{{ formResolver.resolveFieldTitle(chatForm.entity, field.name) | translate }}:</dt>
          @switch (field.type) {
            @case (ChatFormFieldType.DateTime) {
              @let dateTime = chatForm.values?.[field.name];
              @let dateTimeDisplay = dateTime ? (dateTime | dateFormat: 'L LT' : false) : '';
              <dd [title]="dateTimeDisplay">{{ dateTimeDisplay }}</dd>
            }
            @default {
              @let value = fieldValues$[field.name] | async;
              <dd [title]="value">{{ value }}</dd>
            }
          }
        </div>
      }
    </dl>
  } @else {
    <form class="chat-message-form nimbus-form-wrapper" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (formTitle || formDescription) {
        <div class="chat-message-form-header">
          @if (formTitle) {
            <div class="chat-message-form-title">{{ formTitle | translate }}</div>
          }
          @if (formDescription) {
            <div class="chat-message-form-description">{{ formDescription | translate }}</div>
          }
        </div>
      }
      @for (field of chatForm.fields; track field.name) {
        @let action = getFieldAction(field);
        <nimbus-form-row>
          <nimbus-form-control>
            <div class="mat-form-field-relative-wrapper">
              @if (action) {
                <div class="mat-form-filed-action-header">
                  <div class="transparent-border-button" (click)="formActionInvoked.emit(action)">
                    <i class="button-icon" [nimbusIcon]="action.icon"></i>
                    <div class="button-text">
                      {{ action.tooltip | translate }}
                    </div>
                  </div>
                </div>
              }

              @switch (field.type) {
                @case (ChatFormFieldType.DateTime) {
                  <nimbus-input-date-time-picker
                    [id]="field.name"
                    [formControlName]="field.name"
                    [label]="formResolver.resolveFieldTitle(chatForm.entity, field.name) | translate"
                    [required]="field.required"
                  ></nimbus-input-date-time-picker>
                }
                @case (ChatFormFieldType.Text) {
                  @if (field.secret) {
                    <nimbus-input-password
                      [id]="field.name"
                      [formControlName]="field.name"
                      [label]="formResolver.resolveFieldTitle(chatForm.entity, field.name) | translate"
                      [required]="field.required"
                    ></nimbus-input-password>
                  } @else {
                    <nimbus-input-string
                      [id]="field.name"
                      [formControlName]="field.name"
                      [label]="formResolver.resolveFieldTitle(chatForm.entity, field.name) | translate"
                      [required]="field.required"
                      [maxLength]="getFieldMaxLength(field)"
                    ></nimbus-input-string>
                  }
                }
                @case (ChatFormFieldType.Reference) {
                  @switch (field.referenceType) {
                    @case ('OrganizationUnit') {
                      <nimbus-input-organization-unit-autocomplete
                        [id]="field.name"
                        [formControlName]="field.name"
                        [label]="formResolver.resolveFieldTitle(chatForm.entity, field.name) | translate"
                        [options]="optionsByField[field.name] | async"
                        [required]="field.required"
                      ></nimbus-input-organization-unit-autocomplete>
                    }
                    @default {
                      <nimbus-input-autocomplete
                        defaultSearch
                        [id]="field.name"
                        [formControlName]="field.name"
                        [label]="formResolver.resolveFieldTitle(chatForm.entity, field.name) | translate"
                        [options]="optionsByField[field.name] | async"
                        [required]="field.required"
                      ></nimbus-input-autocomplete>
                    }
                  }
                }
              }
            </div>
          </nimbus-form-control>
        </nimbus-form-row>
      }

      @if (chatForm.operation === ChatFormOperation.Confirm) {
        <nimbus-form-row>
          <nimbus-form-control>
            <nimbus-input-text-area
              id="declineComment"
              [formControl]="declineComment"
              [label]="TranslationKeys.ChatWidgetFormRejectComment | translate"
            ></nimbus-input-text-area>
          </nimbus-form-control>
        </nimbus-form-row>
      }

      <div class="chat-message-form-actions">
        <button type="button" nimbusSecondaryButton [disabled]="isSubmitting" (click)="onReject()">
          {{ TranslationKeys.ChatWidgetFormReject | translate }}
        </button>
        <button type="submit" nimbusPrimaryButton [disabled]="form.invalid || isSubmitting">
          {{ submitLabel | translate }}
        </button>
      </div>
    </form>
  }
}
